<script setup lang="ts">

import {Plus} from "@element-plus/icons-vue";
import {genFileId, UploadProps, UploadRequestOptions, UploadUserFile} from "element-plus";
import {uploadImage} from "@/utils/cos.ts";
import {ProgressInfo} from "cos-js-sdk-v5";
import {ref} from "vue";

defineProps<{
  max: number;
}>()

const fileList = ref<UploadUserFile[]>([])
const previewVisible = ref(false)
const previewList = ref<string[]>([])
const handlePreview: UploadProps['onPreview'] = (uploadFile) => {
  previewVisible.value = true
  previewList.value = [uploadFile.url!]
}

const upload = (options: UploadRequestOptions) => {
  if (options.file) {
    uploadImage(options.file, {
      onTaskReady: (taskId: string) => {
        console.log(taskId)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.status = "uploading"
          }
          return item
        })
      },
      onProgress: (progressData: ProgressInfo) => {
        console.log(progressData.percent)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.percentage = progressData.percent * 100
          }
          return item
        })
      },
      onUploadFail: (err: string) => {
        console.log(err)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.status = "fail"
          }
          return item
        })
      },
      onFileFinish: (url: string) => {
        console.log(url)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.url = url
            item.status = "success"
          }
          return item
        })
      }
    })
  }
}

const init = (content: string[]) => {
  fileList.value = []
  for (let i = 0; i < content.length; i++) {
    fileList.value.push({
      uid: genFileId(),
      url: content[i],
      name: content[i],
      status: "success"
    })
  }
}

const checkAllUploadSuccess = (): boolean => {
  let allSuccess = true
  if (fileList.value.length > 0) {
    fileList.value.map((item) => {
      if (item.status !== "success") {
        allSuccess = false
        return false
      }
    })
  }
  return allSuccess
}

const getImageUrls = (): string => {
  const pathsArray: string[] = []
  if (fileList.value.length > 0) {
    fileList.value.map((item) => {
      if (item.status === "success") {
        pathsArray.push(item.url || '')
      }
    })
  }
  return pathsArray.join(",")
}

defineExpose({
  fileList, init, checkAllUploadSuccess, getImageUrls
})
</script>

<template>
  <el-upload
      :multiple="true"
      :class="(fileList && fileList.length >= max) ? `hide_box` : `` + (!fileList || (fileList.length === 0) ? ` mb-8px`: ` `)"
      v-model:file-list="fileList"
      list-type="picture-card"
      :http-request="upload"
      :on-preview="handlePreview"
      accept=".jpg,.jpeg,.png"
      :limit="3"
  >
    <el-icon>
      <Plus/>
    </el-icon>
  </el-upload>
  <el-image-viewer @close="previewVisible = false" :url-list="previewList" v-if="previewVisible"/>
</template>

<<style scoped>
.hide_box ::v-deep(.el-upload--picture-card) {
  display: none;
}
</style>
